import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRu = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	style: { enableBackground: "new 0 0 512 512" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			style: { fill: "#F5F5F5" },
			d: "M512,200.092H0V97.103c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828 V200.092z"
		}),
		/* @__PURE__ */ _jsx("path", {
			style: { fill: "#FF4B55" },
			d: "M503.172,423.724H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.908h512v102.988 C512,419.772,508.047,423.724,503.172,423.724z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 200.088,
			style: { fill: "#41479B" },
			width: 512,
			height: 111.812
		})
	]
});
export default SvgRu;
